/**
 * 操作ログ詳細検索の時刻 Select の value と、API/URL 由来の時刻表記を一致させる（時・分をゼロ埋め）。
 */
export function normalizeHalfHourSelectTime(hm: string | undefined): string | undefined {
  if (hm == null || hm.trim() === '') return hm
  const m = hm.trim().match(/^(\d{1,2}):(\d{1,2})/)
  if (!m) return hm.trim().slice(0, 5)
  const h = parseInt(m[1], 10)
  const min = parseInt(m[2], 10)
  if (Number.isNaN(h) || Number.isNaN(min)) return hm.trim().slice(0, 5)
  return `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`
}
